import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ReauthPopupComponent } from '../reauth-popup.component';
import { LoginService, PractitionerPayload } from 'app/services/login/login.service';
import { SessionInactivityService } from 'app/services/session-inactivity/session-inactivity.service';

@Injectable({
  providedIn: 'root'
})
export class ReAuthPopupService {

  constructor(
    private readonly dialog: MatDialog,
    private readonly loginService: LoginService,
    private sessionInactivityService: SessionInactivityService,
  ) { }

  showPopup(): Observable<boolean> {
    const dialogRef = this.dialog.open(ReauthPopupComponent, {
      panelClass: 'dialog-class',
      backdropClass: 'dialog-blur-backdrop',
      data: {},
      disableClose: true,
      closeOnNavigation: false
    });

    return dialogRef.afterClosed();
  }

  onReAuth() {
    if (this.loginService.reauthenticationRequired) return;
    console.log("on reauth triggered")
    this.loginService.onPartialLogout();
    this.showPopup().subscribe(result => {
      if (result === true) {
        this.loginService.reauthenticationRequired = false;
        // Re-auth successful, resume session tracking or other logic
        this.sessionInactivityService.onReInit();
        this.loginService.loggedIn$.next(true);
      } else if (result === false) {
        this.loginService.revokeOnLogout();
      }
    });
  }

  getUserEmail(): string {
    return localStorage.getItem("providerId");
  }

  saveTokenOnReLogin(url: string) {
    const hashIndex = url.indexOf('#');
    if (hashIndex === -1) {
      return;
    }

    const hash = url.substring(hashIndex + 1); // Get part after '#'
    const pairs = hash.split('&'); // Split by & to get key=value pairs
    const result: { [key: string]: string } = {};

    for (const pair of pairs) {
      const [key, value] = pair.split('=');
      if (key && value) {
        result[decodeURIComponent(key)] = decodeURIComponent(value);
      }
    }

    if (result['authToken']) {
      localStorage.setItem('authToken', result['authToken']);
    }

    if (result['idToken']) {
      localStorage.setItem('idToken', result['idToken']);
      const tokenDetails: PractitionerPayload = this.loginService.decodeToken(result['idToken'])
      if (tokenDetails.providerId) {
        localStorage.setItem('providerId', tokenDetails.providerId);
      }
    }
  }
}
